export default function (state, val) {
    let id = val ? (val.id ? val.id : '') : '';
    let item, newFilter;
    if (id) {
        item = state.filters.filter(i => {
            return i.id === val.id;
        })[0];
    }
    if (!item) {
        newFilter = true;
        item = {
            id: '' + new Date().getTime(),
            name: 'Фильтр ' + (state.filters.length + 1),
            searchClick: true,
            dateType: 1,
            dateStep: 1,
            dateInt: 0,
            dateRound: false,
            CurrencyId: [],
            DepartmentList: [],
            ManagerList: [],
            Direction: 0,
            ContragentID: 0,
            ContragentName: '',
            ContragentType: 0,
            ContragentSearchTypeId: 0,
            AgreementCode: '',
            RequestNumber: '',
            PaymentReason: '',
            DocumentNumber: '',
            NoDetailedOnly: false,
            AccountNumber: '',
            PaymentOperationID: '',
            CategoryId: '',
            PaymentTypeId: '',
            CashList: [],
            PaymentAccountList: [],
            StatementName: '',
            MinAmount: 0,
            MaxAmount: 0,
            PaySystemTransactionId: '',
          PaymentMethodId: null,
            DateStatement: '',
            KindOfPayId: '',
        }
    }
    if (val) {
        for (let k in val) {
            if (typeof item[k] !== 'undefined') item[k] = val[k];
        }
    }
    if (newFilter) {
        state.filters.push(item);
    }
}